import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import styles from './index.module.scss';

const imgJP = {
    pc: 'https://websiteoss.ecoflow.com/upload/image/1775284497305/3-pc.jpg',
    h5: 'https://websiteoss.ecoflow.com/upload/image/1775284497489/3-m.jpg',
};

export default function TheComp() {
    const { t } = useLang('delta3series');

    const configs = {
        pc: imgJP.pc,
        h5: imgJP.h5,
        label: t('E_label'),
        title: t('E_title'),
        position: 'hover',
        theme: 'white',
    };

    return (
        <div className={`${styles.TheComp} GtmModuleData-section range4`} data-section-id="D3-E" id='D3-E'>
            <EfSection {...configs} />
        </div>
    );
}
